var React = require('react');

function Success (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm-1 12c-.264 0-.519-.103-.707-.292l-2-2c-.39-.391-.39-1.023 0-1.414.391-.391 1.023-.391 1.414 0l1.138 1.138 3.323-4.986c.306-.46.926-.584 1.387-.277.46.307.583.927.277 1.387l-4 6c-.166.249-.436.41-.733.44-.034.003-.066.005-.099.005"}));
}

Success.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Success;

Success.default = Success;
